import React, { useState } from 'react'
import { Photo } from 'types/globalTypes'
import ButtonSpinner from './ButtonSpinner'
import Coverimage from 'assets/Images/Coverimage.svg'
import { useFileUploadMutation } from 'api/FileUpload/FileUpload'
import { Upload, Image } from 'antd'
import Icon from 'assets/Images/icon.svg'
import { useFileUploadRequest } from 'api/FileUpload'
import heic2any from 'heic2any'
import { infoMessage } from 'api/global'

interface UploadSingleImageProps {
  fileId: string
  setFileId: React.Dispatch<React.SetStateAction<string>>
  file: Photo
  setFile: React.Dispatch<React.SetStateAction<Photo>>
  sourceType?:
    | 'guardian_profile'
    | 'user_profile'
    | 'organization_profile'
    | 'mentor_profile'
    | 'organizer_profile'
    | 'authorized_adult_profile'
    | 'kid_profile'
    | 'amenity'
    | 'live_update'
    | 'other'
    | 'icon'
}

const UploadSingleImage: React.FC<UploadSingleImageProps> = ({
  fileId,
  setFileId,
  file,
  setFile,
  sourceType,
}) => {
  const [uploading, setUploading] = useState(false)

  const { mutate: fileUploadMutation } = useFileUploadMutation()

  const handleChangeImage = async (info: any) => {
    const fileObj = new FormData()
    setUploading(true)
    if (
      info.file.originFileObj.type === 'image/heic' ||
      info.file.originFileObj.name.endsWith('.heic')
    ) {
      try {
        const blob = await heic2any({
          blob: info.file.originFileObj,
          toType: 'image/jpeg',
          quality: 0.9,
        })
        const jpegFile = new File(
          [blob] as any,
          info.file.originFileObj.name.replace(/\.heic$/i, '.jpeg'),
          {
            type: 'image/jpeg',
          },
        )
        fileObj.append('file', jpegFile)
      } catch (err) {
        infoMessage('HEIC conversion failed')
        return
      }
    } else {
      fileObj.append('file', info.file.originFileObj)
    }
    let newFile = {
      title: info?.file.name || 'image',
      description: 'hero_image',
      altText: 'iamge',
      sourceType: sourceType || 'organizer_profile',
    }

    fileUploadMutation(
      { payload: fileObj, newFile },
      {
        onSuccess: (fileSuccessData: any) => {
          setFile(fileSuccessData.uploadResult)
          setFileId(fileSuccessData.id)
          setUploading(false)
        },
        onError: (error: any) => {
          setUploading(false)
        },
      },
    )
  }

  const handleDeleteImage = () => {
    setFile(undefined)
    setFileId(undefined)
  }

  const uploadButton = (
    <div>
      <div>
        {uploading ? (
          <ButtonSpinner size={16} color="#2ba7ca" />
        ) : (
          <div className="flex items-center gap-10px px-16px py-10px bg-grey radius-12 pointer">
            <img src={Coverimage} alt="avatar" />
            <span>Upload image</span>
          </div>
        )}
      </div>
    </div>
  )
  return (
    <div className="flex gap-16px items-center">
      <Upload
        onChange={handleChangeImage}
        multiple={false}
        maxCount={1}
        showUploadList={false}
      >
        {uploadButton}
      </Upload>
      {file && (
        <div className="img-preview">
          <img
            alt="#img"
            className="closing-icon"
            src={Icon}
            onClick={handleDeleteImage}
          />
          <Image
            className="br-12"
            height={100}
            width={100}
            src={file?.original}
            rootClassName={'mb-10'}
          />
        </div>
      )}
    </div>
  )
}

export default UploadSingleImage
